import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "defaultIndex", "id", "className", "onChange"],
    _excluded2 = ["children", "id"],
    _excluded3 = ["children", "id"],
    _excluded4 = ["children", "id"],
    _excluded5 = ["children", "id"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, createRef, useContext, useEffect, useState } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import { Styled } from './Tabs.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var ModalTabsContext = createContext();

var useModalTabsContext = function useModalTabsContext() {
  return useContext(ModalTabsContext);
};

var ModalTabs = forwardRef(function (_ref, ref) {
  var _cx;

  var children = _ref.children,
      _ref$defaultIndex = _ref.defaultIndex,
      defaultIndex = _ref$defaultIndex === void 0 ? 0 : _ref$defaultIndex,
      id = _ref.id,
      customClassName = _ref.className,
      _ref$onChange = _ref.onChange,
      onChangeFromProp = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-modal__tabs"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useState = useState(defaultIndex),
      _useState2 = _slicedToArray(_useState, 2),
      activeTabIndex = _useState2[0],
      setActiveTabIndex = _useState2[1];

  return _jsx(ModalTabsContext.Provider, {
    value: {
      activeTabIndex: activeTabIndex
    },
    children: _jsx(Styled.ModalTabs, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className,
      defaultIndex: defaultIndex,
      onChange: function onChange(tabIndex) {
        onChangeFromProp(tabIndex);
        setActiveTabIndex(tabIndex);
      }
    }, rest), {}, {
      children: children
    }))
  });
});
var ModalTabList = forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      id = _ref2.id,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return _jsx(Styled.ModalTabList, _objectSpread(_objectSpread({
    ref: ref,
    id: id
  }, rest), {}, {
    children: children
  }));
});
var ModalTab = forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      id = _ref3.id,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return _jsx(Styled.ModalTab, _objectSpread(_objectSpread({
    ref: ref,
    id: id
  }, rest), {}, {
    children: children
  }));
});
var ModalTabPanels = forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
      id = _ref4.id,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  var _useModalTabsContext = useModalTabsContext(),
      activeTabIndex = _useModalTabsContext.activeTabIndex;

  ref = createRef();
  useEffect(function () {
    ref.current.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [activeTabIndex, ref]);
  return _jsx(Styled.ModalTabPanels, _objectSpread(_objectSpread({
    ref: ref,
    id: id
  }, rest), {}, {
    children: children
  }));
});
var ModalTabPanel = forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      id = _ref5.id,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return _jsx(Styled.ModalTabPanel, _objectSpread(_objectSpread({
    ref: ref,
    id: id
  }, rest), {}, {
    children: children
  }));
});
export { ModalTabs, ModalTabList, ModalTab, ModalTabPanels, ModalTabPanel };